import { render } from "./Wallet.vue?vue&type=template&id=25e2a48a"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=25e2a48a&lang=css"
script.render = render

export default script